import { DEFAULT_FRONTEND_ENVIRONMENT } from '../../constants'
import { useSelector } from 'react-redux'
import { selectClientConfigurationQueryResult } from '../crs/selectors'
import { useGetThemeAndBrandingAssetsQuery } from './generated'

export const useGetClientBrandingQuery = () => {
  const { data } = useSelector(selectClientConfigurationQueryResult)
  return useGetThemeAndBrandingAssetsQuery(
    { name: data?.frontend_environment || DEFAULT_FRONTEND_ENVIRONMENT },
    { skip: !data },
  )
}
